import {Booking} from "../../data-access/api-booking/Booking";
import {Injectable} from "@angular/core";
import {Store, StoreConfig} from "@datorama/akita";

export interface BookingData {
  bookings: Booking[];
  bookingPage: number;
  bookingHasNext: boolean;
  bookingTotalItems: number;
  error?: unknown;
}

export type BookingState = BookingData;

function createInitialState(): BookingState {
  return {
    bookings: [],
    bookingPage: 0,
    bookingHasNext: true,
    bookingTotalItems: 0,
    error: undefined,
  }
}

@Injectable({
  providedIn: 'root'
})
@StoreConfig({
  name: 'booking'
})
export class BookingStore extends Store<BookingState> {
  constructor() {
    super(createInitialState());
  }
}
